<template>
  <button
    :type="type"
    class="block bg-nucleus-primaryBlue dark:bg-nucleusDark-primaryBlue hover:bg-nucleus-primaryMouseOver dark:hover:bg-nucleusDark-primaryMouseOver p-3 text-white dark:text-nucleusDark-darkerBlue text-lg text-center shadow-md rounded-full transition w-full disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-nucleus-primaryBlue relative"
    :class="ifLoading()"
  >
    <span
      v-if="loading"
      class="absolute w-full h-full top-0 left-0 rounded-full bg-nucleus-primaryBlue text-white flex justify-center items-center"
    >
      <span
        class="loader ease-linear rounded-full border-2 border-t-2 border-nucleus-primaryMouseOver h-6 w-6 animate-spin"
      ></span
    ></span>
    {{ name }}
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    type: String,
    loading: Boolean,
  },
  methods: {
    ifLoading() {
      if (this.loading) return "opacity-75 cursor-not-allowed";
    },
  },
})
export default class Home extends Vue {}
</script>

<style lang="scss" scoped>
.loader {
  border-top-color: #ffffff;
}
</style>
